import { render, staticRenderFns } from "./IsolationAdd.vue?vue&type=template&id=16880df5&scoped=true&"
import script from "./IsolationAdd.vue?vue&type=script&lang=js&"
export * from "./IsolationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16880df5",
  null
  
)

export default component.exports